import { render, staticRenderFns } from "./InfoCardProjects.vue?vue&type=template&id=1a0de5f1&scoped=true&"
import script from "./InfoCardProjects.vue?vue&type=script&lang=js&"
export * from "./InfoCardProjects.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardProjects.vue?vue&type=style&index=0&id=1a0de5f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0de5f1",
  null
  
)

export default component.exports